import { render, staticRenderFns } from "./PrivacyList.vue?vue&type=template&id=085dccf3&"
import script from "./PrivacyList.vue?vue&type=script&lang=js&"
export * from "./PrivacyList.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085dccf3')) {
      api.createRecord('085dccf3', component.options)
    } else {
      api.reload('085dccf3', component.options)
    }
    module.hot.accept("./PrivacyList.vue?vue&type=template&id=085dccf3&", function () {
      api.rerender('085dccf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/PrivacyList.vue"
export default component.exports